import type { UsageFeeTierSelectFragment } from '~/modules/pricing/graphql/fragments/usageFeeTier.generated';

export enum IUsageFeeTierKey {
  /**
   * 0 - 20_000
   */
  BASIC = 'BASIC',
  /**
   * 20_000 - 100_000
   */
  MEDIUM = 'MEDIUM',
  /**
   * 100_000 - 500_000
   */
  LARGE = 'LARGE',
  /**
   * 500_000 - 1_000_000
   */
  EXTRA_LARGE = 'EXTRA_LARGE',
  /**
   * 1_000_000 - Infinity
   */
  MAX = 'MAX',
}

export interface IUsageFeeTier extends UsageFeeTierSelectFragment {
  min: number;
  max: number;
  tierKey: IUsageFeeTierKey;
}
